import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
import { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAblyChannelId } from '../../chat/selectors/chatv2Selectors';
import { chatV2Actions } from '../../chat/slices/chatv2';
import { AblyRealtimeClientContext } from '../context/AblyRealtimeClientProvider';
export const useCopilotV2PublishAblyMessage = () => {
  const ablyRealtimeClient = useContext(AblyRealtimeClientContext);
  const ablyChannelId = useSelector(selectAblyChannelId);
  const dispatch = useDispatch();

  /**
   * Publishes a message to the Ably channel
   * @param {MessageWithMetadata} payload - The message to publish
   * @returns {void}
   *
   * @description
   * This function publishes a message to the Ably channel
   */
  const publishAblyMessage = useCallback(payload => {
    if (!ablyChannelId) {
      return;
    }
    const callbackHandler = error => {
      // null indicates successful publish
      if (error === null) {
        // TODO - handle successful case, should there be a loading state?
      } else {
        consoleIfNotProd.error('Failure publishing message to Ably channel via publishAblyMessage: ', error);
        dispatch(chatV2Actions.chatUserMessageSentException(payload));
      }
    };
    const {
      context,
      messageTracking,
      customCopilotId,
      message,
      type,
      sourceHostAppPathname,
      // TODO: BE is not currently using this, but we had it for v1 - determine if it is needed for tracking in v2
      interactiveInput
    } = payload;
    const currentAblyChannel = ablyRealtimeClient.channels.get(ablyChannelId);
    dispatch(chatV2Actions.chatUserMessageSentPending(payload));
    currentAblyChannel.publish('user_message', {
      context,
      messageTracking,
      customCopilotId,
      message,
      type,
      sourceHostAppPathname,
      // TODO: BE is not currently using this, but we had it for v1 - determine if it is needed for tracking in v2
      interactiveInput
    }, callbackHandler);
  }, [ablyRealtimeClient, ablyChannelId, dispatch]);
  return publishAblyMessage;
};